/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeriesGraphPoint
 */
export interface SeriesGraphPoint {
    /**
     * 
     * @type {string}
     * @memberof SeriesGraphPoint
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesGraphPoint
     */
    cRITICAL?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesGraphPoint
     */
    hIGH?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesGraphPoint
     */
    mEDIUM?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesGraphPoint
     */
    lOW?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesGraphPoint
     */
    iNFO?: number;
}

/**
 * Check if a given object implements the SeriesGraphPoint interface.
 */
export function instanceOfSeriesGraphPoint(value: object): value is SeriesGraphPoint {
    return true;
}

export function SeriesGraphPointFromJSON(json: any): SeriesGraphPoint {
    return SeriesGraphPointFromJSONTyped(json, false);
}

export function SeriesGraphPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesGraphPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : json['date'],
        'cRITICAL': json['CRITICAL'] == null ? undefined : json['CRITICAL'],
        'hIGH': json['HIGH'] == null ? undefined : json['HIGH'],
        'mEDIUM': json['MEDIUM'] == null ? undefined : json['MEDIUM'],
        'lOW': json['LOW'] == null ? undefined : json['LOW'],
        'iNFO': json['INFO'] == null ? undefined : json['INFO'],
    };
}

export function SeriesGraphPointToJSON(json: any): SeriesGraphPoint {
    return SeriesGraphPointToJSONTyped(json, false);
}

export function SeriesGraphPointToJSONTyped(value?: SeriesGraphPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'CRITICAL': value['cRITICAL'],
        'HIGH': value['hIGH'],
        'MEDIUM': value['mEDIUM'],
        'LOW': value['lOW'],
        'INFO': value['iNFO'],
    };
}

